module.exports = __webpack_public_path__ + "img/dots.f9139dda.png";